// extracted by mini-css-extract-plugin
export default {"adminButton":"Menu_adminButton__Ub-dx"};